import React from 'react';
import { FiCheckCircle } from 'react-icons/fi';
import { Button } from '../../ui/Button';
import { useLanguage } from '../../../contexts/LanguageContext';

/**
 * Success message component for quote modal
 *
 * @param {Object} props
 * @param {Function} props.onClose - Close handler
 */
export const SuccessMessage = ({ onClose }) => {
  const { t } = useLanguage();
  return (
    <div className="flex flex-col items-center justify-center p-8 text-center" role="alert">
      <div className="text-center py-12 px-6">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6 animate-bounce-subtle">
          <FiCheckCircle className="w-10 h-10 text-green-600" />
        </div>
        <h3 className="text-2xl sm:text-3xl font-display font-bold text-gray-900 mb-4">
          {t('quote.successTitle')}
        </h3>
        <p className="text-gray-600 mb-8 max-w-md mx-auto leading-relaxed">
          {t('quote.successMessage')}
        </p>
        <Button onClick={onClose} size="lg" className="min-w-[200px] shadow-xl hover:shadow-green-200 hover:bg-green-600 hover:border-green-600">
          {t('quote.newQuote')}
        </Button>
      </div>
    </div>
  );
};
